import { StyleSheet, View } from 'react-native';
import Svg, { Circle, Line, Rect } from 'react-native-svg';
import { ONBOARDING_COLORS } from '../../src/tutorial/constants/onboardingContent.constants';

/**
 * Faint pitch markings behind every onboarding screen (matches design flow 2a). Purely
 * decorative and non-interactive; scaled to fill via viewBox slice so it reads the same on
 * any phone width. Kept as its own component so `TutorialItem` stays light (and its unit test
 * can mock this out instead of pulling in react-native-svg).
 */
export function TutorialPitchBackdrop() {
  const stroke = ONBOARDING_COLORS.pitchLine;
  return (
    <View style={StyleSheet.absoluteFill} pointerEvents="none">
      <Svg
        width="100%"
        height="100%"
        viewBox="0 0 390 780"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
      >
        {/* top penalty box */}
        <Rect x={70} y={-60} width={250} height={130} rx={4} stroke={stroke} strokeWidth={2} />
        <Rect x={120} y={-60} width={150} height={70} rx={4} stroke={stroke} strokeWidth={2} />
        {/* halfway line + centre circle */}
        <Line x1={0} y1={390} x2={390} y2={390} stroke={stroke} strokeWidth={2} />
        <Circle cx={195} cy={390} r={80} stroke={stroke} strokeWidth={2} />
        {/* bottom penalty box */}
        <Rect x={70} y={710} width={250} height={130} rx={4} stroke={stroke} strokeWidth={2} />
        <Rect x={120} y={770} width={150} height={70} rx={4} stroke={stroke} strokeWidth={2} />
      </Svg>
    </View>
  );
}
